import React from 'react'
import { Button, Text } from './Themed'
import { useColors } from '../constants/useColors'
import type { MarketProps } from '../types'
import type { ViewStyle } from 'react-native'

type MarketLozengeProps = {
    market: MarketProps,
    text_size?:number,
    is_active?:boolean,
    style?:ViewStyle,
    onSelect: (market:MarketProps) => void
}
export const MarketLozenge = ({ style, market, text_size, is_active, onSelect }:MarketLozengeProps) => {
    const Colors = useColors();
    const handleSelect = () => {
        if(!onSelect){ return }
        onSelect(market)
    }
    
    return (
        <Button float style={{ flexDirection:'row', alignItems:'center', margin:4, borderWidth:1, borderColor:is_active?Colors.text.success: Colors.borders.light, borderRadius:100, padding:10, paddingRight:text_size??20, paddingLeft:text_size??20, ...style }} onPress={() => handleSelect()}>

            <Text size={text_size??16} color={is_active ? Colors.text.success : undefined} theme='h2'>{market.stat_label?market.stat_label:market.type}</Text>
        </Button>
    )
}

export default MarketLozenge